export default {
  createSnackbarMessage: (state, payload) => state.push(payload),

  removeSnackbarMessage: (state, id) => {
    const index = state.findIndex(snackbar => snackbar.id === id);
    if (index === -1) {
      return;
    }
    state.splice(index, 1);
  }
};
